import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { State, City } from "country-state-city";
import { Loader2, Lock, Truck, ShieldCheck, CreditCard, Settings2, ClipboardList, CheckCircle } from "lucide-react";
import kgvHero from '../resource/kgvhero1.png';


const PayOneRupee = () => {
  const navigate = useNavigate();
  const [availableCities, setAvailableCities] = useState([]);
  const [isLoadingCities, setIsLoadingCities] = useState(false);


  const INDIA_CODE = "IN";

  // Effect removed - using hook instead

  const bikeModelsData = {
    "100-125cc": {
      "Hero Splendor Plus": 100,
      "Hero HF Deluxe": 100,
      "Hero Passion Pro": 113,
      "Hero Splendor iSmart": 113.2,
      "Bajaj Platina 100": 102,
      "Bajaj CT 100": 102,
      "Bajaj Platina 110": 115.45,
      "TVS Sport": 109.7,
      "TVS Radeon": 109.7,
      "TVS Star City Plus": 109.7,
      "Honda CD 110 Dream": 109.5,
      "Honda Livo": 109.5,
      "Honda SP 125": 124,
      "Honda Shine": 123.94,
      "Hero Glamour": 124.7,
      "Hero Super Splendor": 124.7,
      "Bajaj Pulsar 125": 124.4,
      "Bajaj Discover 125": 124.5,
      "TVS Raider 125": 124.8,
    },
    "150-180cc": {
      "Bajaj Pulsar 150": 149.5,
      "Bajaj Pulsar N150": 149.68,
      "TVS Apache RTR 160": 159.7,
      "TVS Apache RTR 160 4V": 159.7,
      "Yamaha FZ Fi": 149,
      "Yamaha FZ-S Fi": 149,
      "Yamaha FZ-X": 149,
      "Suzuki Gixxer 155": 155,
      "Honda Unicorn": 162.7,
      "Honda XBlade": 162.71,
      "Honda CB Hornet 160R": 162.71,
      "Bajaj Pulsar 180F": 178.6,
      "TVS Apache RTR 180": 177.4,
    },
  };

  const [dealerEmail, setDealerEmail] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    idProof: "",
    idNumber: "",
    vehicleNo: "",
    model: "",
    bikeCC: "",
    chassisNo: "",
    batteryType: "NMC",
    batteryCapacity: "50 KM Range",
    batteryCost: 13000,
    quantity: 1,
    state: "",
    city: "",
    branch: "",
    country: "India",
  });

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");

  const sendKitOtp = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const cleanPhone = formData.phone.replace(/\s+/g, "");
      const res = await axios.post("https://auth.kgvl.co.in/api/otp/send", { phone: cleanPhone });
      if (res.data.success) {
        setOtpSent(true);
      } else {
        setOtpError(res.data.message || "Failed to send OTP");
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || err.message || "Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyKitOtp = async () => {
    setOtpLoading(true);
    setOtpError("");
    try {
      const cleanPhone = formData.phone.replace(/\s+/g, "");
      const res = await axios.post("https://auth.kgvl.co.in/api/otp/verify", { phone: cleanPhone, otp: otpCode });
      if (res.data.success) {
        setOtpVerified(true);
      } else {
        setOtpError(res.data.message || "Invalid OTP");
      }
    } catch (err) {
      setOtpError(err.response?.data?.message || err.message || "Invalid OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLocationChange = async (field, value) => {
    const apiUrl = 'https://auth.kgvl.co.in';
    if (field === "state") {
      setFormData((prev) => ({
        ...prev,
        state: value,
        city: "",
        branch: "",
      }));
      try {
        const allCities = City.getCitiesOfState(INDIA_CODE, value);
        setAvailableCities(allCities);
      } catch (err) {
        console.error("Failed to fetch cities:", err);
        setAvailableCities([]);
      }
    } else if (field === "city") {
      setFormData((prev) => ({
        ...prev,
        city: value,
        branch: value,
      }));

      try {
        const encodedCity = encodeURIComponent(value);
        const response = await fetch(
          `${apiUrl}/dealer/email/${encodedCity}`
        );

        if (response.ok) {
          const data = await response.json();
          if (data.success && data.dealerEmail) {
            setDealerEmail(data.dealerEmail);
          } else {
            setDealerEmail("");
          }
        } else {
          setDealerEmail("");
        }
      } catch (err) {
        console.error("Error fetching dealer email:", err);
        setDealerEmail("");
      }
    }
  };

  const calculateBaseCost = () => {
    const cc = parseInt(formData.bikeCC);
    if (cc >= 100 && cc <= 125) return 39000;
    if (cc > 125 && cc <= 190) return 45000;
    return 0;
  };

  const calculateSubtotal = () => {
    return (
      calculateBaseCost() + (formData.batteryCost || 0) * (formData.quantity || 1)
    );
  };

  const calculateGst = () => {
    return Math.round(calculateSubtotal() * 0.18);
  };

  const calculateTotalAmount = () => {
    return calculateSubtotal() + calculateGst();
  };

  const handlePayment = async () => {
    if (!otpVerified) {
      return alert("❌ Please verify your mobile number first.");
    }
    try {
      const totalAmount = calculateTotalAmount();

      if (totalAmount === 0) {
        return alert("❌ Invalid configuration");
      }

      // Validate phone
      const phoneNumber = formData.phone.replace(/\s+/g, '');
      if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
        return alert("❌ Invalid phone number. Must be 10 digits starting with 6-9");
      }

      const payableAmount = 5000;
      const apiUrl = 'https://auth.kgvl.co.in';
      
      console.log("🔄 Creating order...");

      // Generate a unique order ID
      const orderId = `order_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

      // Step 1: Create Cashfree order
      const response = await axios.post(`${apiUrl}/api/order/checkout`, {
        amount: payableAmount,
        customerName: formData.name,
        customerEmail: formData.email,
        customerPhone: phoneNumber,
        orderId: orderId // Pass custom order ID
      });

      console.log("✅ Order created:", response.data);

      if (!response.data.success || !response.data.sessionId) {
        throw new Error("Failed to create payment session");
      }

      // Store form data in localStorage or state to use after payment
      localStorage.setItem('pendingOrderData', JSON.stringify({
        ...formData,
        orderId: response.data.orderId,
        totalAmount: totalAmount,
        payableAmount: payableAmount
      }));

      // Step 2: Open Cashfree checkout
      const cashfree = window.Cashfree({
        mode: "production" // Change to "production" for live
      });

      const checkoutOptions = {
        paymentSessionId: response.data.sessionId,
        returnUrl: `https://www.kgvl.co.in/paymentsuccess?order_id=${response.data.orderId}`,  
      };

      console.log("💳 Opening Cashfree checkout...");
      
      cashfree.checkout(checkoutOptions);

    } catch (err) {
      console.error("❌ Error:", err);
      alert(`❌ ${err.response?.data?.message || err.message || "Payment failed"}`);
    }
  };

  return (
    <div 
      className="min-h-screen py-12 px-4 relative overflow-hidden"
      style={{
        backgroundImage: `
          radial-gradient(circle at 1px 1px, rgba(34, 197, 94, 0.05) 1px, transparent 0),
          linear-gradient(to bottom right, #f0fdf4, #ffffff, #ecfdf5)
        `,
        backgroundSize: '24px 24px, 100% 100%'
      }}
    >
      {/* Hero Section */}
      <div 
        className="max-w-3xl mx-auto text-center mb-12 p-8 md:p-10 rounded-3xl shadow-2xl border border-green-700/30 relative overflow-hidden text-white"
        style={{
          backgroundImage: `
            radial-gradient(circle at 1px 1px, rgba(74, 222, 128, 0.15) 1px, transparent 0),
            linear-gradient(to bottom right, rgba(20, 83, 45, 0.95), rgba(6, 78, 59, 0.98))
          `,
          backgroundSize: '20px 20px, 100% 100%'
        }}
      >
        {/* Glowing blur blobs for premium depth */}
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-green-400/20 rounded-full blur-3xl pointer-events-none"></div>
        
        <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-bold bg-green-500/10 text-green-400 mb-6 border border-green-500/20 uppercase tracking-wider relative z-10">
          ⚡ Next-Gen Hybrid Technology
        </span>
        <h1 className="text-3xl md:text-4xl font-extrabold mb-4 tracking-tight text-white leading-tight relative z-10">
          Convert Your Ride. <br />
          <span className="bg-gradient-to-r from-green-400 to-emerald-300 bg-clip-text text-transparent">
            Unleash the KGV E-Hybrid Kit
          </span>
        </h1>
        <p className="text-green-100/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed font-medium relative z-10">
          Transform your standard petrol motorcycle into a high-efficiency smart hybrid. Enjoy dual-fuel performance, reduced emissions, and eco-friendly electric commuting without giving up your favorite bike.
        </p>
      </div>

      {/* Payment Steps */}
      <div className="bg-white/90 backdrop-blur-xl p-8 md:p-10 rounded-3xl mb-16 shadow-xl max-w-4xl mx-auto border border-gray-100">
        <h2 className="text-2xl font-extrabold text-gray-800 mb-2 text-center flex items-center justify-center gap-3">
          <CreditCard className="w-7 h-7 text-emerald-600" /> Easy 3-Step Payment Process
        </h2>
        <p className="text-gray-500 mb-10 text-center text-sm md:text-base max-w-xl mx-auto leading-relaxed font-medium">
          Secure your premium hybrid kit order today with our flexible, interest-free payment schedule.
        </p>
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Card 1 */}
          <div className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 relative flex flex-col items-center md:items-start text-center md:text-left">
            <span className="absolute -top-4 left-1/2 md:left-6 transform -translate-x-1/2 md:translate-x-0 bg-gradient-to-r from-emerald-600 to-green-600 text-white rounded-xl px-4 py-1 text-xs font-bold uppercase tracking-wider shadow-md">
              Step 1
            </span>
            <div className="mt-4 font-extrabold text-xl text-gray-800 mb-2">Booking Advance</div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Pay a booking advance of ₹5,000 today to lock in current pricing and reserve your inventory.
            </p>
          </div>
          
          {/* Card 2 */}
          <div className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 relative flex flex-col items-center md:items-start text-center md:text-left">
            <span className="absolute -top-4 left-1/2 md:left-6 transform -translate-x-1/2 md:translate-x-0 bg-gradient-to-r from-emerald-600 to-green-600 text-white rounded-xl px-4 py-1 text-xs font-bold uppercase tracking-wider shadow-md">
              Step 2
            </span>
            <div className="mt-4 font-extrabold text-xl text-gray-800 mb-2">30% Configuration</div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Pay 30% of the total cost within 7 days to confirm your custom specifications and initiate manufacturing.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 relative flex flex-col items-center md:items-start text-center md:text-left">
            <span className="absolute -top-4 left-1/2 md:left-6 transform -translate-x-1/2 md:translate-x-0 bg-gradient-to-r from-emerald-600 to-green-600 text-white rounded-xl px-4 py-1 text-xs font-bold uppercase tracking-wider shadow-md">
              Step 3
            </span>
            <div className="mt-4 font-extrabold text-xl text-gray-800 mb-2">Delivery Balance</div>
            <p className="text-gray-500 text-sm leading-relaxed">
              Settle the remaining balance at the time of delivery or dispatch to your preferred location.
            </p>
          </div>
        </div>
      </div>

      {/* Configuration Section */}
      <div id="build-your-perfect-kit" className="max-w-2xl mx-auto mb-16 p-8 md:p-10 bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-gray-100">
        <h2 className="text-2xl font-extrabold text-gray-800 mb-2 flex items-center gap-3">
          <Settings2 className="w-6 h-6 text-emerald-600" /> Build Your Perfect Kit
        </h2>
        <p className="text-gray-500 text-sm mb-8 font-medium">
          Customize your kit specifications and battery options to match your bike model.
        </p>

        <div className="space-y-6">
          {/* Bike Model */}
          <div>
            <label className="block mb-2 text-sm font-semibold text-gray-700">
              Select Bike Model
            </label>
            <select
              name="model"
              value={formData.model}
              onChange={(e) => {
                const selectedModel = e.target.value;
                let selectedCC = null;
                let found = false;

                Object.entries(bikeModelsData).forEach(([ccGroup, models]) => {
                  if (models[selectedModel] !== undefined) {
                    selectedCC = models[selectedModel];
                    found = true;
                  }
                });

                if (found) {
                  setFormData({
                    ...formData,
                    model: selectedModel,
                    bikeCC: selectedCC,
                  });
                }
              }}
              required
              className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium"
            >
              <option value="">-- Select Your Bike Model --</option>
              <optgroup label="100cc – 125cc">
                {Object.keys(bikeModelsData["100-125cc"]).map((model) => (
                  <option key={model} value={model}>
                    {model}
                  </option>
                ))}
              </optgroup>
              <optgroup label="150cc – 180cc">
                {Object.keys(bikeModelsData["150-180cc"]).map((model) => (
                  <option key={model} value={model}>
                    {model}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>

          {/* Bike CC */}
          <div>
            <label className="block mb-2 text-sm font-semibold text-gray-700">Engine CC</label>
            <input
              type="text"
              name="bikeCC"
              value={formData.bikeCC}
              readOnly
              placeholder="Will auto-fill based on model"
              className="w-full rounded-xl px-4 py-3 bg-gray-50 border border-gray-200 text-gray-500 cursor-not-allowed shadow-inner font-medium"
            />
          </div>

          {/* Battery Type */}
          <div>
            <label className="block mb-3 text-sm font-semibold text-gray-700">
              Battery Type
            </label>
            <div className="flex gap-4">
              {["NMC"].map((type) => (
                <button
                  key={type}
                  type="button"
                  className={`px-6 py-2.5 rounded-xl font-bold border transition-all duration-300 ${
                    formData.batteryType === type
                      ? "bg-gradient-to-r from-emerald-600 to-green-700 text-white border-emerald-600 shadow-md shadow-emerald-700/20 scale-[1.02]"
                      : "bg-white text-gray-700 border-gray-200 hover:border-emerald-300 hover:bg-emerald-50/10"
                  }`}
                  onClick={() => setFormData({ ...formData, batteryType: type })}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          {/* Battery Range Options */}
          <div>
            <label className="block mb-3 text-sm font-semibold text-gray-700">
              Select Battery Range
            </label>
            <div className="grid grid-cols-2 gap-4">
              <div
                className={`border rounded-2xl p-5 text-center cursor-pointer transition-all duration-300 ${
                  formData.batteryCapacity === "50 KM Range" || formData.batteryCost === 13000
                    ? "bg-gradient-to-r from-emerald-600 to-green-700 text-white border-emerald-600 shadow-md shadow-emerald-700/25 scale-[1.02]"
                    : "bg-white text-gray-800 border-gray-200 hover:border-emerald-300 hover:shadow-md"
                }`}
                onClick={() =>
                  setFormData({
                    ...formData,
                    batteryCapacity: "50 KM Range",
                    batteryCost: 13000,
                    quantity: 1
                  })
                }
              >
                <div className="font-extrabold text-xl">50 KM Range</div>
                <div className="text-xs opacity-80 font-medium mt-1">1 Battery Pack</div>
                <div className="text-base mt-2 font-bold opacity-95">₹13,000</div>
              </div>
              <div
                className={`border rounded-2xl p-5 text-center cursor-pointer transition-all duration-300 ${
                  formData.batteryCapacity === "100 KM Range" || formData.batteryCost === 26000
                    ? "bg-gradient-to-r from-emerald-600 to-green-700 text-white border-emerald-600 shadow-md shadow-emerald-700/25 scale-[1.02]"
                    : "bg-white text-gray-800 border-gray-200 hover:border-emerald-300 hover:shadow-md"
                }`}
                onClick={() =>
                  setFormData({
                    ...formData,
                    batteryCapacity: "100 KM Range",
                    batteryCost: 26000,
                    quantity: 1
                  })
                }
              >
                <div className="font-extrabold text-xl">100 KM Range</div>
                <div className="text-xs opacity-80 font-medium mt-1">2 Battery Packs</div>
                <div className="text-base mt-2 font-bold opacity-95">₹26,000</div>
              </div>
            </div>
          </div>

          {/* Total Cost */}
          <div className="border border-emerald-100 pt-6 mt-8 bg-gradient-to-br from-emerald-50/50 to-green-50/30 p-6 rounded-2xl flex flex-col gap-3">
            <div className="flex justify-between items-center text-sm font-semibold text-gray-600">
              <span>Kit & Battery Subtotal:</span>
              <span className="text-gray-800 font-bold">₹{calculateSubtotal().toLocaleString("en-IN")}</span>
            </div>
            <div className="flex justify-between items-center text-sm font-semibold text-gray-600">
              <span>GST (18%):</span>
              <span className="text-gray-800 font-bold">₹{calculateGst().toLocaleString("en-IN")}</span>
            </div>
            <div className="border-t border-emerald-200/60 pt-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div>
                <p className="text-xs uppercase tracking-wider text-emerald-700 font-bold">Total Build Value</p>
                <p className="text-xs text-gray-500 font-medium">(Inclusive of 18% GST)</p>
              </div>
              <p className="text-3xl font-extrabold text-emerald-800">
                ₹{calculateTotalAmount().toLocaleString("en-IN")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Form and Image Section */}
      <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 md:p-12 max-w-7xl mx-auto border border-gray-100">
        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-2 text-center flex items-center justify-center gap-3">
          <ClipboardList className="w-7 h-7 text-emerald-600" /> Complete Your Booking Details
        </h2>
        <p className="text-gray-500 text-sm mb-10 text-center font-medium">
          Please fill in your authentic details to process the secure payment verification and register your kit.
        </p>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Form */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handlePayment();
            }}
            className="space-y-5"
          >
            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={otpVerified}
                placeholder="Enter your full name"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Phone Number *
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                disabled={otpVerified}
                placeholder="Enter 10-digit mobile number"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            {/* OTP Verification UI */}
            {!otpVerified && (
              <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl space-y-3">
                {!otpSent ? (
                  <button
                    type="button"
                    onClick={sendKitOtp}
                    disabled={otpLoading || !/^[6-9]\d{9}$/.test(formData.phone.replace(/\s+/g, ""))}
                    className="w-full bg-gradient-to-r from-emerald-600 to-green-700 hover:from-emerald-700 hover:to-green-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-2 px-4 rounded-lg transition duration-200 text-sm flex items-center justify-center gap-2"
                  >
                    {otpLoading ? <Loader2 className="w-4 h-4 animate-spin text-white" /> : "Send OTP"}
                  </button>
                ) : (
                  <div className="space-y-3">
                    <p className="text-xs text-gray-500">An OTP has been sent to {formData.phone}. Please enter it below:</p>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        maxLength={6}
                        placeholder="Enter 6-Digit OTP"
                        value={otpCode}
                        onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-800 placeholder-gray-400 text-sm focus:outline-none focus:border-emerald-500"
                      />
                      <button
                        type="button"
                        onClick={verifyKitOtp}
                        disabled={otpLoading || otpCode.length !== 6}
                        className="bg-gradient-to-r from-emerald-600 to-green-700 hover:from-emerald-700 hover:to-green-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold px-4 py-2 rounded-lg transition duration-200 text-sm flex items-center justify-center"
                      >
                        {otpLoading ? <Loader2 className="w-4 h-4 animate-spin text-white" /> : "Verify"}
                      </button>
                    </div>
                    <div className="flex justify-between items-center text-xs">
                      <button
                        type="button"
                        onClick={sendKitOtp}
                        disabled={otpLoading}
                        className="text-emerald-600 hover:underline"
                      >
                        Resend OTP
                      </button>
                      {otpError && <span className="text-red-600 font-semibold">{otpError}</span>}
                    </div>
                  </div>
                )}
              </div>
            )}

            {otpVerified && (
              <div className="text-xs text-green-700 font-semibold flex items-center gap-1.5 bg-green-50 border border-green-200 px-3 py-2.5 rounded-lg">
                <CheckCircle className="w-4 h-4 text-green-600" /> Phone Number Verified Successfully. You can now fill in the remaining details.
              </div>
            )}

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="your.email@example.com"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                ID Proof Type *
              </label>
              <select
                name="idProof"
                value={formData.idProof}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option value="">-- Select ID Proof --</option>
                <option value="Aadhar">Aadhar Card</option>
                <option value="PAN">PAN Card</option>
                <option value="Driving License">Driving License</option>
              </select>
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                ID Number *
              </label>
              <input
                type="text"
                name="idNumber"
                value={formData.idNumber}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="Enter your ID number"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Vehicle Registration Number *
              </label>
              <input
                type="text"
                name="vehicleNo"
                value={formData.vehicleNo}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="e.g., UP14AB1234"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">
                Chassis Number *
              </label>
              <input
                type="text"
                name="chassisNo"
                value={formData.chassisNo}
                onChange={handleChange}
                required
                disabled={!otpVerified}
                placeholder="Enter chassis number"
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">State *</label>
              <select
                name="state"
                value={formData.state}
                onChange={(e) => handleLocationChange("state", e.target.value)}
                required
                disabled={!otpVerified}
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option value="">-- Select State --</option>
                {State.getStatesOfCountry(INDIA_CODE).map((state) => (
                  <option key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block mb-2 text-sm font-semibold text-gray-700">City *</label>
              <select
                name="city"
                value={formData.city}
                onChange={(e) => handleLocationChange("city", e.target.value)}
                required
                disabled={!otpVerified || isLoadingCities || !formData.state}
                className="w-full rounded-xl px-4 py-3 bg-white border border-gray-200 text-gray-800 focus:outline-none focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10 shadow-sm transition-all duration-200 font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                <option value="">
                  {isLoadingCities
                    ? "Loading cities..."
                    : !formData.state
                    ? "Select state first"
                    : "-- Select City --"}
                </option>
                {availableCities.map((city) => (
                  <option key={city.name} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
              {isLoadingCities && (
                <div className="flex items-center gap-2 mt-2 text-emerald-600">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span className="text-sm">Fetching available cities...</span>
                </div>
              )}
            </div>
            <button
              type="submit"
              disabled={isLoadingCities || !otpVerified}
              className="bg-gradient-to-r from-emerald-600 to-green-700 hover:from-emerald-700 hover:to-green-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-extrabold px-6 py-4 rounded-xl shadow-lg shadow-emerald-700/20 w-full transform transition-all hover:scale-[1.01] active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none text-lg mt-8 flex items-center justify-center gap-2"
            >
              {isLoadingCities ? (
                <span className="flex items-center justify-center gap-2">
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Loading Cities...
                </span>
              ) : (
                <span>Pay ₹5,000 Booking Advance</span>
              )}
            </button>
            
          </form>

          {/* Image */}
          <div className="flex flex-col justify-center items-center bg-gradient-to-br from-emerald-50/50 via-green-50/30 to-transparent border border-emerald-100 rounded-3xl p-8 relative overflow-hidden">
            <div className="absolute inset-0 bg-emerald-400/10 rounded-full blur-3xl opacity-30 animate-pulse pointer-events-none"></div>
            <div className="relative">
              <img
                src={kgvHero}
                alt="KGV Hero"
                className="w-full h-auto max-h-[420px] object-contain drop-shadow-[0_20px_50px_rgba(16,185,129,0.2)] relative z-10"
              />
            </div>
            <div className="mt-8 text-center relative z-10">
              <h3 className="text-xl font-extrabold text-gray-800 mb-2">
                Your Future Ride Awaits
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-sm">
                Join thousands of satisfied riders who have already upgraded their bikes to smart hybrids.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="max-w-5xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 px-4 pb-12">
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex flex-col items-center text-center">
          <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-5 text-emerald-600">
            <Lock className="w-6 h-6" />
          </div>
          <h4 className="font-bold text-gray-800 text-lg mb-2">Secure Transactions</h4>
          <p className="text-sm text-gray-500 leading-relaxed">
            Bank-grade SSL encryption ensures your booking payment is 100% secure.
          </p>
        </div>
        
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex flex-col items-center text-center">
          <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-5 text-emerald-600">
            <Truck className="w-6 h-6" />
          </div>
          <h4 className="font-bold text-gray-800 text-lg mb-2">Express Dispatch</h4>
          <p className="text-sm text-gray-500 leading-relaxed">
            Your custom hybrid kit is manufactured and dispatched within 7-10 business days.
          </p>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 flex flex-col items-center text-center">
          <div className="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-5 text-emerald-600">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <h4 className="font-bold text-gray-800 text-lg mb-2">Warranty Assured</h4>
          <p className="text-sm text-gray-500 leading-relaxed">
            Every component comes with comprehensive official KGV product warranty.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PayOneRupee;
